export default __webpack_public_path__ + "static/media/anu-george.a077be99.jpg";